(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvPhoneNumberInput', drvPhoneNumberInput);
        
    drvPhoneNumberInput.$inject = [];

        /**
         * @ngdoc directive
         * @name drvPhoneNumberInput
         * @description Phone number input which includes E164 validation.
         *
         * @param {string} value - Phone number in E164 format
         * @param {object} field - An entity field object with properties such as 'HelpText', 'Mandatory', etc.
         */
        function drvPhoneNumberInput() {
            drvPhoneNumberInputCtrl.$inject = ['PhoneService'];

            return  {
                templateUrl: 'app/fieldinput/phone-number-input.tmpl.html',
                require: "ngModel",
                scope: {
                },
                controller: drvPhoneNumberInputCtrl,
                controllerAs: 'drvCtrl',
                bindToController: {
                    value: '=ngModel',
                    field: '='
                },
                link: link
            };

            function drvPhoneNumberInputCtrl(PhoneService) {
                /* jshint validthis:true */
                var drvCtrl = this;
                drvCtrl.validatePhoneNumber = validatePhoneNumber;

                /*
                 * Check to see if the phone number is valid
                 */
                function validatePhoneNumber(phoneNumber) {
                    return (_.isNil(phoneNumber) || phoneNumber === '' || PhoneService.validateNumber(phoneNumber));
                }
            }
        }

        /*
         * Link function which will handle validation
         */
        function link($scope, $element, $attrs, $ctrl) {
            $scope.pni[$scope.drvCtrl.field.Name].$validators.formatValid = function required(modelValue, viewValue) {
                return $scope.drvCtrl.validatePhoneNumber(modelValue);
            };
        }
})();